export default __webpack_public_path__ + "673afecdf8c38827872a0d0df38c32d9.wav";